export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7535.ad1e4b95.jpg";